export default "__VITE_ASSET__BnXssEo2__"